import styled from 'styled-components'

// styles
import { WrapTransHistoryItem } from '../../TransactionHistory/TransHistoryItem/index.styles';

const WrapCustomerItem = styled(WrapTransHistoryItem)`
    .wrap-infos {
        .general-infos {
            .left-infos {
                .wrap-id-trans {
                    &:first-of-type {
                        margin-left: 0;
                    }
                }
            }

            .payment-time {
                font-family: "Open Sans";
                font-style: normal;
                font-weight: normal;
                font-size: 13px;
                line-height: 18px;
                letter-spacing: -0.01em;
                color: #313131;
            }
        }
        &.payment-location-infos {
            .row {
                &.payment-location-row {
                    .payment-value {
                        display: flex;
                        .value-item{
                            margin-left: 44px;
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                            .value {
                                font-size: 15px;
                            }
                        }
                    }
                }
            }
        }
    }

`;

export {
    WrapCustomerItem
}